<template>
  <div>
    <div class="foots">
      <div class="mains">
        <div class="l">
          <img src="@/assets/images/logo-1.png" alt="">
        </div>
        <div class="r">
          <ul>
            <li @click="toNext(item.path)" v-for="(item,index) in list" :key="index">{{item.name}}</li>
          </ul>
        </div>
      </div>
      <div class="mains">
        <div class="copyright">
        <span>客服电话：4009959766</span><br>
					© Copyright 2019-2021 北京博久网络科技有限公司 All Rights Reserved. 京ICP证：<a href="https://beian.miit.gov.cn"> <font color="#444"> 京ICP备16007530号 </font></a>
				</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ui-footer',
  data() {
    return {
      active: 0,
      list : [
        {
          name : '首页',
          path : '/home'
        },
        {
          name : '游戏中心',
          path : '/game'
        },
        {
          name : '活动中心',
          path : '/activity'
        },
        {
          name : '关于我们',
          path : '/about'
        },
        {
          name : '加入我们',
          path : '/add'
        },
        {
          name : '纠纷处理',
          path : '/disputeHandling'
        },
        {
          name : '家长监护',
          path : '/guardianshipProject'
        },
        {
          name : '防沉迷系统',
          path : '/antiAddictionSystem'
        }
      ],
      navBtn : false,
    }
  },
  created() {
  },
  mounted() {
  },

  methods: {
    toNext(path){
      if(this.$route.path != path){
        this.$router.push({
          path
        })
      }
    }
  },
}
</script>
<style lang="less" scoped>
 .foots{
   width: 100%;
   font-size: 10px;
   background: #000;
   color: #999;
   padding: 20px 0;
 }
 .mains{
   max-width: 512px;
   height: 100%;
   margin: 0 auto;
   display: flex;
   justify-content: space-between;
   align-items: center;
 }
 .l{
   width: 77px;
   height: 30px;
   img{
     width: auto;
     height: 100%;
   }
 }
 .r{
   width: 70%;
   display: flex;
   justify-content: flex-end;
   ul{
     display: flex;
     align-items: center;
     flex-wrap: wrap;
     li{
       font-size: 8px;
       margin-left: 14px;
       font-weight: normal;
       margin-bottom: 10px;
       cursor: pointer;
       &.on{
         color: #f48041;
       }
       &:hover{
         color: #f48041;
       }
     }
   }
   .btn{
     display: none;
   }
 }
 .copyright{
   width: 100%;
   text-align: center;
    color: #444;
    font-size: 6px;
    font-family: "microsoft Yahei","Arial Narrow";
    /* margin-top: 10px; */
    line-height: 26px;
    a, a:active, a:visited, a:hover, a:target {
        display: inline;
    }
 }
 

  @media (max-width:800px) {
    .l{
      padding-left: 10px;
    }
    .copyright{
        font-size: 8px;
    }
	}
</style>
